import React from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'
import { Button } from '@mindfulchefuk/design-system/Button'

export const ClearRefinementsButton = connectCurrentRefinements(
  ({ items, refine }) =>
    !items.length ? null : (
      <Button
        variant="secondary"
        size="medium"
        type="button"
        onClick={() => refine(items)}
      >
        Clear all filters
      </Button>
    )
)
